'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}
